// extracted by mini-css-extract-plugin
module.exports = {"button":"TransferButton_button__24dOh"};